import { createContext } from "react"
import { AnimatePresence } from "framer-motion"

import useToast from "hooks/popup/useToast"

import Toast from "components/presenters/popup/Toast"

export const ToastStateContext = createContext([])

export const ToastCallbackContext = createContext({
  openToast: () => {},
  closeToast: () => {},
})

const ToastProvider = ({ children }) => {
  const { openedToasts, openToast } = useToast()

  return (
    <ToastCallbackContext.Provider value={{ openToast }}>
      <ToastStateContext.Provider value={openedToasts}>
        {children}
        <AnimatePresence>
          {openedToasts.map(({ id, iconName, desc, top, bottom }) => (
            <Toast key={id} id={id} iconName={iconName} desc={desc} top={top} bottom={bottom} />
          ))}
        </AnimatePresence>
      </ToastStateContext.Provider>
    </ToastCallbackContext.Provider>
  )
}

export default ToastProvider
